<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 69.47 69.47"><defs></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><polygon class="cls-1star" points="34.73 69.47 24.56 59.3 10.17 59.3 10.17 44.91 0 34.73 10.17 24.56 10.17 10.17 24.56 10.17 34.73 0 44.91 10.17 59.3 10.17 59.3 24.56 69.47 34.73 59.3 44.91 59.3 59.3 44.91 59.3 34.73 69.47"/><g class="cls-2star"><path class="cls-3star" d="M29,23.93a7.83,7.83,0,0,1,6-2.32,7.92,7.92,0,0,1,5.63,2,6.64,6.64,0,0,1,2.12,5.07,5.4,5.4,0,0,1-.77,3,22.94,22.94,0,0,1-3.14,3.42,9.88,9.88,0,0,0-2.25,2.78A8.34,8.34,0,0,0,36,41.26H32.87a11.37,11.37,0,0,1,.6-4.06,10.6,10.6,0,0,1,2.66-3.54l1.44-1.39a6.06,6.06,0,0,0,1-1.26,4.33,4.33,0,0,0,.74-2.38,4.54,4.54,0,0,0-1.06-3,4.27,4.27,0,0,0-3.48-1.27,4.27,4.27,0,0,0-4.16,2.18,8.35,8.35,0,0,0-.74,3.51H26.78A8.61,8.61,0,0,1,29,23.93ZM32.8,44.19h3.5v3.67H32.8Z"/></g></g></g></svg>
</template>


<script>
export default {
    name: 'Star'
}
</script>


<style>
.cls-1star{fill:#f68e59;}.cls-2star{isolation:isolate;}.cls-3star{fill:#fff;}
</style>